import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const MarketplaceView = () => import('@/views/MarketplaceView.vue');
const MarketplaceStorefrontView = () => import('@/views/marketplace/StorefrontView.vue');
const MarketplaceProductView = () => import('@/views/marketplace/ProductView.vue');
const MarketplaceShoppingCartView = () => import('@/views/marketplace/ShoppingCartView.vue');
const MarketplaceCheckoutView = () => import('@/views/marketplace/CheckoutView.vue');
const MarketplaceOrderDetailView = () => import('@/views/marketplace/OrderDetailView.vue');
const MarketplaceOrderHistoryView = () => import('@/views/marketplace/OrderHistoryView.vue');
const MarketplaceOrderFailedView = () => import('@/views/marketplace/FailedView.vue');

export const NAME_MARKETPLACE = 'Marketplace';
export const NAME_MARKETPLACE_STOREFRONT = 'MarketplaceStorefront';
export const NAME_MARKETPLACE_PRODUCT = 'MarketplaceProduct';
export const NAME_MARKETPLACE_SHOPPING_CART = 'MarketplaceShoppingCart';
export const NAME_MARKETPLACE_CHECKOUT = 'MarketplaceCheckout';
export const NAME_MARKETPLACE_ORDER_DETAIL = 'MarketplaceOrderDetail';
export const NAME_MARKETPLACE_ORDER_HISTORY = 'MarketplaceOrderHistory';
export const NAME_MARKETPLACE_ORDER_FAILED = 'MarketplaceOrderFailed';
export const PATH_MARKETPLACE = 'marketplace';

const children = [
  { path: '', component: MarketplaceStorefrontView, name: NAME_MARKETPLACE_STOREFRONT, meta: { dataLoaders: ['project_document', 'demo_data', 'features', 'payments_base', 'shopping_cart'] } },
  { path: 'product/:id', component: MarketplaceProductView, name: NAME_MARKETPLACE_PRODUCT, meta: { dataLoaders: ['project_document', 'demo_data', 'features', 'payments_base', 'shopping_cart'] } },
  { path: 'cart', component: MarketplaceShoppingCartView, name: NAME_MARKETPLACE_SHOPPING_CART, meta: { dataLoaders: ['project_document', 'demo_data', 'features', 'payments_base', 'shopping_cart'] } },
  { path: 'checkout', component: MarketplaceCheckoutView, name: NAME_MARKETPLACE_CHECKOUT, meta: { dataLoaders: ['project_document', 'demo_data', 'features', 'payments_base', 'shopping_cart'] } },
  { path: 'order/:id', component: MarketplaceOrderDetailView, name: NAME_MARKETPLACE_ORDER_DETAIL, meta: { dataLoaders: ['project_document', 'demo_data', 'features', 'payments_base', 'order_detail'] } },
  { path: 'order/history', component: MarketplaceOrderHistoryView, name: NAME_MARKETPLACE_ORDER_HISTORY, meta: { dataLoaders: ['project_document', 'demo_data', 'features', 'payments_base', 'shopping_cart'] } },
  { path: 'order/failed', component: MarketplaceOrderFailedView, name: NAME_MARKETPLACE_ORDER_FAILED },
];

export const route: DiscoveredRouteModule = {
  id: 'app.marketplace',
  scope: 'app',
  moduleKey: 'marketplace',
  name: NAME_MARKETPLACE,
  path: PATH_MARKETPLACE,
  component: MarketplaceView,
  meta: {
    dataLoaders: ['project_document', 'demo_data', 'features', 'payments_base', 'shopping_cart']
  },
  requiresFeature: 'payments.marketplace',
  children,
};


